import { globalStores } from '@/editor/stores';
import { Vector3 } from 'three';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';
import { LineSegments2, LineSegmentsGeometry } from 'three/examples/jsm/Addons.js';
import BaseModel3d from '../BaseModel3d';
import { pixelRatio3d } from '@/editor/math/const';
import { IBoxOutlineParams } from '../../type';
import { getBoxVertices } from '../utils';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';

export class BoxOutlineModel extends BaseModel3d {
  constructor() {
    super({ id: 'BoxOutline' });

    globalStores.editorStateStore.sceneInfo.scene3d.scene.add(this.model);
  }

  update(params?: IBoxOutlineParams) {
    this.clearModel();

    if (!params) return;

    this.createModel(params);
  }

  createModel(params: IBoxOutlineParams) {
    const { color, rotation } = params;
    let { width, thickness, height, x, y, z } = params;
    x /= pixelRatio3d;
    y /= pixelRatio3d;
    z /= pixelRatio3d;
    width /= pixelRatio3d;
    thickness /= pixelRatio3d;
    height /= pixelRatio3d;

    const min = new Vector3(-width / 2, -thickness / 2, -height / 2);
    const max = new Vector3(width / 2, thickness / 2, height / 2);
    const vertices = getBoxVertices(min, max);

    const geometry = new LineSegmentsGeometry();
    geometry.setPositions(vertices);
    const material = new LineMaterial({
      color,
      linewidth: 1,
      transparent: false,
      depthTest: false,
      depthWrite: false
    });
    const boxOutline = new LineSegments2(geometry, material);

    boxOutline.renderOrder = ENTITY_RENDER_ORDER.selectedOutline;
    boxOutline.position.set(x, y, z);
    boxOutline.rotateZ(rotation);
    this.model.add(boxOutline);
  }
}
